import { render, staticRenderFns } from "./member.vue?vue&type=template&id=008a3c58&scoped=true&"
import script from "./member.vue?vue&type=script&lang=js&"
export * from "./member.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./member.vue?vue&type=style&index=0&id=008a3c58&scoped=true&lang=css&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "008a3c58",
  "38d4448a"
  
)

export default component.exports